export default __webpack_public_path__ + "maps-guides-markers-annotations-960-af0f6ce5998aaaca85bc3e5eb35c6f37.webp";